import { Modal } from './ui.tsx';
import { formatDateTime, formatNumber } from '../lib/format.ts';
import type { VideoItem } from '../../../shared/types.ts';

/** Player embutido do vídeo — assistir sem sair do dashboard. O link externo
 * continua disponível no rodapé para quem preferir abrir no YouTube mesmo. */
export function VideoDetailModal({ video, onClose }: { video: VideoItem; onClose: () => void }) {
  return (
    <Modal title={video.title} onClose={onClose} wide>
      <div className="stack">
        <div className="video-embed">
          <iframe
            src={`https://www.youtube.com/embed/${video.videoId}`}
            title={video.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>

        <div className="detail-grid">
          <div>
            <span className="text-micro text-muted">Publicado</span>
            <p className="text-body">
              {video.publishedAt ? formatDateTime(video.publishedAt) : formatDateTime(video.fetchedAt)}
            </p>
          </div>
          {video.viewCount !== null && (
            <div>
              <span className="text-micro text-muted">Visualizações</span>
              <p className="text-body tabular-nums">{formatNumber(video.viewCount)}</p>
            </div>
          )}
        </div>

        <a className="link" href={video.url} target="_blank" rel="noreferrer noopener">
          Assistir no YouTube
        </a>
      </div>
    </Modal>
  );
}
